// extracted by mini-css-extract-plugin
module.exports = {"panel":"panel_atb0R","body":"body_9GmWA","title":"title_orU36"};